
export const SERIES_COLORS = [
  "#2a78d6",
  "#eb6834",
  "#1baf7a",
  "#eda100",
  "#e87ba4",
  "#008300",
];

export const CHART_INK = {
  title: "#1E293B",
  label: "#475569",
  muted: "#94A3B8",
  axis: "rgba(15,23,42,0.18)",
  grid: "rgba(15,23,42,0.07)",
  surface: "#F8F6F1",
};

export const seriesColor = (i) => SERIES_COLORS[i % SERIES_COLORS.length];

export function defaultChartData(chartType) {
  if (chartType === "table") {
    return {
      columns: ["Item", "Owner", "Status"],
      rows: [
        ["Landing page", "Sam", "In progress"],
        ["Pricing copy", "Alex", "Done"],
        ["Launch email", "Jo", "Not started"],
      ],
    };
  }
  if (chartType === "timeline") {
    return {
      events: [
        { label: "Kickoff", when: "Week 1" },
        { label: "Draft", when: "Week 3" },
        { label: "Review", when: "Week 5" },
        { label: "Launch", when: "Week 8" },
      ],
    };
  }
  if (chartType === "pie" || chartType === "donut") {
    return {
      categories: ["Design", "Build", "Test", "Launch"],
      series: [{ name: "Effort", values: [30, 40, 20, 10] }],
    };
  }
  if (chartType === "stacked") {
    return {
      categories: ["Q1", "Q2", "Q3", "Q4"],
      series: [
        { name: "New", values: [12, 18, 14, 22] },
        { name: "Returning", values: [8, 9, 13, 11] },
      ],
    };
  }
  if (chartType === "line" || chartType === "area") {
    return {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"],
      series: [{ name: "Signups", values: [8, 14, 12, 22, 29] }],
    };
  }
  return {
    categories: ["Q1", "Q2", "Q3", "Q4"],
    series: [{ name: "Revenue", values: [12, 19, 15, 27] }],
  };
}

export const CHART_TITLES = {
  bar: "Revenue by quarter",
  column: "Revenue by quarter",
  stacked: "Signups by quarter",
  line: "Signups by week",
  area: "Signups by week",
  pie: "Effort split",
  donut: "Effort split",
  table: "Workstreams",
  timeline: "Launch plan",
};

export function makeChart(chartType, x, y, id) {
  const isWide = chartType === "table" || chartType === "timeline";
  return {
    id,
    type: "chart",
    chartType,
    x, y,
    w: isWide ? 380 : 320,
    h: chartType === "timeline" ? 150 : 240,
    title: CHART_TITLES[chartType] || "Chart",
    data: defaultChartData(chartType),
  };
}

export function niceMax(value) {
  if (!Number.isFinite(value) || value <= 0) return 10;
  const pow = Math.pow(10, Math.floor(Math.log10(value)));
  const step = [1, 2, 2.5, 5, 10].find((s) => value <= s * pow) ?? 10;
  return step * pow;
}

export const chartMax = (data, stacked) => {
  const series = data?.series || [];
  if (!series.length) return 10;
  if (stacked) {
    const totals = (data.categories || []).map((_, i) =>
      series.reduce((sum, s) => sum + (Number(s.values?.[i]) || 0), 0)
    );
    return niceMax(Math.max(...totals, 0));
  }
  return niceMax(Math.max(...series.flatMap((s) => (s.values || []).map(Number)), 0));
};
